import moment from 'moment';
import { Col, Row } from 'react-bootstrap';
import { formatDate } from '../../utils';
import G2MonitoringChart from './G2MonitoringChart';

const G2Monitoring = ({ monitoringBlock, g2Model }) => {
  const sprayData = monitoringBlock.alcm_spray_data;
  const trapCatchPeakDate = monitoringBlock.g2_trap_catch_peak_date;
  const eggPeakDate = monitoringBlock.g2_egg_peak_date;

  const trapCatchData = g2Model.trap_catch;
  const eggData = g2Model.egg.map((egg) => {
    return {
      ...egg,
      amount: (egg.amount / 40) * 100
    };
  });

  const sprayDates = (sprayData || [])
    .map((sd) => sd.date)
    .filter(Boolean)
    .sort((a, b) => moment(a).valueOf() - moment(b).valueOf());

  return (
    <Row>
      <Col>
        <G2MonitoringChart trapCatchData={trapCatchData} eggData={eggData} />
        <div className='mt-3'>
          <div>
            <b>Trap Catch Peak Date:</b> {formatDate(trapCatchPeakDate)}
          </div>
          <div>
            <b>Egg Peak Date:</b> {formatDate(eggPeakDate)}
          </div>
          <div>
            <b>Spray Dates:</b>{' '}
            {sprayDates.length
              ? sprayDates.map((date) => formatDate(date)).join(', ')
              : 'N/A'}
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default G2Monitoring;

